import React from 'react';
import Chart from 'react-apexcharts';
import { pieChartOptions } from '../charts';
import './PieChartCard.css';

const PieChartCard = ({ pieChartData, pieChartHeight, pieChartWidth, pieChartTitle }) => {
    return (
        <div className='pieChartCard'>
            <Chart
                options={{
                    ...pieChartOptions,
                    labels: pieChartData.labels  // Set labels here
                }} 
                series={pieChartData.series}   // Values for the area chart
                type="pie"                     // Chart type
                height={pieChartHeight}                    // Adjust the height if needed
                width={pieChartWidth}
            />
            <p>{pieChartTitle}</p>
        </div>
    )
}

export default PieChartCard